import React from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "@emisgroup/acp-application-intl";
import { IRootState } from "../../../../../../reducer/CombineReducer";
import { IFieldDetails } from "../../../CreateSchedule/redux/Types";
import { getWeekDays } from "../../GetDataSourceValues";
import { Checkbox, FormElement } from "../../../../../Common/UI/Index";
import "../Common/Style.scss";

export interface IWeeklyConfigViewProp {
  // OnWeekDayCheckBoxSelect: (e: React.SyntheticEvent<any, Event>) => void;
  onWeekDayCheckBoxSelect: (name: string) => ((isChecked: boolean) => void);
  selectedWeekDay: IFieldDetails;
  disabledFields: boolean;
}

/**
 * Component will be rendered for reccurence type weekly. 
 * Responsible for rendering the weekly checkbox components in UI
 */
const WeeklyConfigView = (props: IWeeklyConfigViewProp): JSX.Element => {
  const { t: translate } = useTranslation();
  const weekType = "week";
  const scheduling = useSelector((state: IRootState) => state.scheduling);
  const { schedulingDetails } = scheduling;
  const { recurrenceData } = schedulingDetails;

  /**
   * Generates the weekdays based on WeekdaysTypeText interface
   * If selectedWeekDays available in redux, then selected week days will be checked else 
   *   default selection will be rendered
   */
  const generateWeekDays = (): Array<JSX.Element> => {
    const weekDaysList: JSX.Element[] = [];
    getWeekDays().forEach((days: string, index: number) => {
      const check = (recurrenceData?.selectedWeekDays) ?
        recurrenceData?.selectedWeekDays.includes(+index) : false;
      weekDaysList.push(
        <Checkbox
          className="ebt-schedule-weekday"
          key={weekType + "-" + days}
          data-testid={weekType + "-" + days + "-test"}
          id={weekType + "-" + days}
          labelText={translate(days) }
          name={index.toString()}
          onChange={props.onWeekDayCheckBoxSelect(index.toString())}
          checked={check}
          disabled={props.disabledFields}
        />);
    });

    return weekDaysList;
  };

  return (
    <FormElement errorText={props.selectedWeekDay.errorText}>
      <div className="ebt-schedule_weekly-config" data-testid="schedule-create-weekly-component">
        {generateWeekDays()}
      </div>
    </FormElement>
  );
};

export default WeeklyConfigView;

